module.exports = __webpack_public_path__ + "static/media/31.eaa1804a.jpg";